interface ErrorLabelProps {
  text: string;
}

const ErrorLabel = (props: ErrorLabelProps) => {
  return <label className="mt-[2px] text-[14px] text-red">{props.text}</label>;
};

export default ErrorLabel;
